type PercentageValue = number | string | null | undefined;

/**
 * Valida la distribución porcentual de la condición de pago de un pedido.
 * Retorna el mensaje de error o null si la distribución es válida.
 * Con 1 pago no hay distribución que validar.
 */
export const validatePaymentsDistribution = (
    paymentsCount: number,
    percentage1: PercentageValue,
    percentage2: PercentageValue
): string | null => {
    if (paymentsCount !== 2) {
        return null;
    }

    const isEmpty = (value: PercentageValue) =>
        value === null || value === undefined || String(value).trim() === '';

    if (isEmpty(percentage1) || isEmpty(percentage2)) {
        return 'Debe ingresar el porcentaje de ambos pagos.';
    }

    const first = Number(percentage1);
    const second = Number(percentage2);

    if (!Number.isFinite(first) || !Number.isFinite(second)) {
        return 'Los porcentajes de pago deben ser valores numéricos.';
    }

    if (first <= 0 || second <= 0 || first >= 100 || second >= 100) {
        return 'Los porcentajes de pago deben ser mayores a 0 y menores a 100.';
    }

    // Tolerancia mínima para evitar falsos negativos por aritmética de punto flotante.
    if (Math.abs(first + second - 100) > 0.001) {
        return 'La suma de los porcentajes de pago debe ser exactamente 100%.';
    }

    return null;
};
